import { ChangeDetectionStrategy, Component, computed, forwardRef, inject, input, model, OnInit, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectChangeEvent, SelectModule } from 'primeng/select';
import { OpsRegion } from 'src/app/api/commonInterfaces';
import { OpsRegionService } from 'src/app/api/ops-region.service';

@Component({
  selector: 'app-ops-region-single-dropdown',
  imports: [SelectModule, FormsModule],
  templateUrl: './ops-region-single-dropdown.component.html',
  styleUrl: './ops-region-single-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OpsRegionSingleDropdownComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OpsRegionSingleDropdownComponent implements OnInit, ControlValueAccessor {

  private writtenValue: any

  formValueType = input<"OpsRegion" | "idString">("OpsRegion")

  writeValue(obj: any): void {
    this.writtenValue = obj

    this.setSelectedRegions(obj)

  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
  }


  onChange: any = () => { };
  onTouched: any = () => { };
  disabled = false;

  opsRegionService = inject(OpsRegionService)

  opsRegions = signal<OpsRegion[]>([])

  dropdownOptions = computed(() => this.opsRegions().map(r => ({ label: r.name, value: r })))

  selectedOpsRegions = model<OpsRegion | null>(null)

  ngOnInit(): void {
    this.opsRegionService.getOpsRegions().subscribe(opsRegions => {
      this.opsRegions.set(opsRegions)
      //need to handle the case where ngmodel writes the value before we're initialized
      if (this.writtenValue) {
        this.setSelectedRegions(this.writtenValue)
      }
    })
  }

  setSelectedRegions(region: OpsRegion | string) {

    let regionId: number

    if (region) {
      if (typeof region === "string") {
        regionId = Number.parseInt(region, 10)
      }
      else {
        regionId = region.id
      }
    }
    this.selectedOpsRegions.set(this.opsRegions().find(r => r.id === regionId) ?? null)

  }

  onRegionSelected(event: SelectChangeEvent) {
    switch (this.formValueType()) {
      case "OpsRegion": {
        this.onChange(event.value)
        break
      }
      case "idString": {
        this.onChange(event.value.id.toString())
      }
    }
  }


}
